import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import LayerUtils from "@vision/core-map-api/src/utils/LayerUtils";
import { Component, Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

@Component({
  template: "",
  standalone: false,
})
export abstract class XyzLayerResultsDialogComponent {
  hide = true;

  isLoading = false;

  urlXYZLayer: string = null;

  urlStyles: string = null;

  layers: any[];

  url: string;

  error: boolean = false;

  isAuthRequired: boolean = false;

  username: string = "";

  password: string = "";

  formatPercentLabel = (value: number) => `${value}%`;

  newLayerForm = new FormGroup({
    newXYZLayerName: new FormControl(""),
    newXYZLayerOpacity: new FormControl(100),
  });

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected geoJSONDatabaseService: GeoJSONDatabaseService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
  ) {
    this.url = data.url;
    this.username = data.username;
    this.password = data.password;
    this.isLoading = true;
    this.isAuthRequired = data.isAuthRequired;
    this.getXYZLayer();
  }

  getXYZLayer() {
    let { url } = this;
    url = decodeURIComponent(url);
    if (this.isTileUrl(url)) {
      this.urlXYZLayer = url;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      this.error = true;
      document.getElementById("lblError").innerHTML = "No layers were returned";
    }
  }

  isTileUrl(url: string): boolean {
    return url.includes("{x}") && url.includes("{y}") && url.includes("{z}");
  }

  changeCheckLayer(checked: boolean, layer: any) {
    layer.checked = checked;
  }

  anyChecked(): boolean {
    return this.urlXYZLayer !== null;
  }

  addXYZLayer() {
    const url = this.urlXYZLayer;
    let extraParams;

    if (this.isAuthRequired && this.username.length > 0 && this.password.length > 0) {
      extraParams = {
        URL_ORIGIN: url,
        USERNAME: this.username,
        PASSWORD: this.password,
      };
    }
    const layerNames = [];

    const layersText = layerNames.join(",");
    let name = this.newLayerForm.get("newXYZLayerName").value;
    const opacity = this.newLayerForm.get("newXYZLayerOpacity").value / 100;
    if (name.length === 0) {
      name = "Custom XYZ Layer";
    }

    const layer = {
      source: ViewerConstants.SOURCE_NAME.XYZ,
      url,
      extraParams,
      removable: true,
      editable: false,
      owner: true,
      layer: layersText,
      isBase: false,
      opacity,
      visible: true,
      realId: `${name.replace(/ /g, "")}_${LayerUtils.layerGuid()}`,
      id: `${name}_${LayerUtils.layerGuid()}`,
      name,
      panelInclude: true,
      order: ViewerConstants.USER_LAYER_BASE_ZINDEX,
      userId: this.viewerConfigurationService.getViewerConfiguration().userId,
    };

    const layerToSave = LayerUtils.processLayer(layer) as unknown as Viewerlayer;
    this.saveLayer(layerToSave);
    this.matDialog.closeAll();
  }

  abstract saveLayer(layer: Viewerlayer);
}
